<template>
	<div class="task-calendar-item-container py-2">
		<v-row class="ma-0 px-3" justify="space-between">
			<div>
				<LeaveIcon :color="color" width="24" height="24" />
			</div>
			<CalendarItemMenu
				v-if="!eventObject.leave_paid"
				:type="event_holiday"
				:color="'rgba(25, 42, 62, 0.5)'"
				:privileges="privileges"
				:isApproved="eventObject.leave_approved"
				:isPaid="eventObject.leave_paid"
				@click-menu-item="$emit('click-menu-item', $event)"
				@delete="$emit('delete')"
				@click.stop />
		</v-row>
		<v-row class="ma-0">
			<v-col cols="12" class="py-0">
				<div class="item-title-text">{{ eventObject.description }}</div>
			</v-col>
		</v-row>
		<v-row v-if="eventObject.all_day" class="ma-0 px-3" justify="space-between">
			<div class="item-time-text">
				<span>{{ formatWeek(eventObject.start_date) }}&nbsp;&nbsp;</span>
				<span>{{ formatDate(eventObject.start_date) }}</span>
			</div>
			<div v-if="eventObject.start_date !== eventObject.end_date" class="item-time-text">
				<span>{{ formatWeek(eventObject.end_date) }}&nbsp;&nbsp;</span>
				<span>{{ formatDate(eventObject.end_date) }}</span>
			</div>
		</v-row>
		<v-row v-if="!eventObject.all_day" class="ma-0">
			<v-col cols="12" class="py-0">
				<div class="item-time-text">
					<span>{{ formatWeek(eventObject.start_date) }}&nbsp;&nbsp;</span>
					<span>{{ formatDate(eventObject.start_date) }}&nbsp;&nbsp;</span>
					<span>{{ formatTime(eventObject.start_date) }}</span>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="invitees.length !== 0"  class="mx-2 my-2">
			<div v-for="invite of invitees" :key="invite.id">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<v-user-avatar
								size="24"
								class="text-caption text-decoration-none mx-1"
								:code="formatName(invite.employee.display_name)"
								:image="`/api/addressbook/${invite.employee.id}/image.png`"
							/>
						</div>
					</template>
					<span class="task-calendar-item-text task-calendar-item-main ">{{ formatName(invite.employee.display_name) }}</span>
				</v-tooltip>
			</div>
		</v-row>
	</div>
</template>
<script>
import LeaveIcon from "@/components/icons/leave";
import CalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";

import moment from 'moment';

const Event_Holiday = 'holiday';

export default {
	name: 'CalendarTimesheetItem',
	props: {
		eventObject: {
			type: Object,
			default: () => {}
		},
		privileges: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: ''
		}
	},
	components: {
		CalendarItemMenu,
		LeaveIcon
	},
	data() {
		this.event_holiday = Event_Holiday;
		return {}
	},
	computed: {
		invitees() {
			let invitee_arr = [];
			if (this.eventObject && this.eventObject.invitees.length !== 0) {
				invitee_arr = this.eventObject.invitees;
			}
			return invitee_arr;
		}
	},
	methods: {
		formatWeek(date_str) {
			return moment(date_str).format('ddd');
		},
		formatDate(date_str) {
			return moment(date_str).format('DD MMM YYYY');
		},
		formatTime(date_str) {
			return moment(date_str).format('hh:mm a');
		},
		formatName(name) {
			let display_name = '';

			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		}
	}
}
</script>
<style lang="scss" scoped>
.task-calendar-item-container {
  width: 100%;
	height: 100%;
  background: #FFFFFF;
  border: 1px solid #FFB946;
  box-shadow: 0px 2px 4px rgba(25, 42, 62, 0.12);
  border-radius: 4px;
}
.item-title-text {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #C18014
}
.item-time-text {
	font-family: Roboto;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.4px;
	color: #192A3EB2;
}
.task-calendar-item-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.task-calendar-item-column {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}
.task-calendar-item-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #192A3E;
}
.task-calendar-item-text {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.task-calendar-item-main {
  font-weight: 500;
}
.task-calendar-item-sub {
  font-weight: 400;
}
.task-calendar-item-color-main {
  color: #192A3E;
}
.task-calendar-item-color-sub {
  color: rgba(25, 42, 62, 0.5);
}
</style>